var exports = {
  "Ef": "UserAreaPopout.module__customStatusRow___ZWVhZz",
  "fF": "UserAreaPopout.module__customStatusPlaceholder___ZWVhZz",
  "yB": "UserAreaPopout.module__customStatusPlaceholderText___ZWVhZz",
  "mo": "UserAreaPopout.module__customStatusPlaceholderIcon___ZWVhZz",
  "Ar": "UserAreaPopout.module__copyUsernameButton___ZWVhZz",
  "kL": "UserAreaPopout.module__container___ZWVhZz",
  "qr": "UserAreaPopout.module__footer___ZWVhZz",
  "mH": "UserAreaPopout.module__actionGroup___ZWVhZz",
  "Gv": "UserAreaPopout.module__editProfileButton___ZWVhZz",
  "hP": "UserAreaPopout.module__actionButton___ZWVhZz",
  "k3": "UserAreaPopout.module__actionDivider___ZWVhZz",
  "d3": "UserAreaPopout.module__actionButtonDisabled___ZWVhZz",
  "gE": "UserAreaPopout.module__actionIcon___ZWVhZz",
  "Iz": "UserAreaPopout.module__actionContent___ZWVhZz",
  "ZJ": "UserAreaPopout.module__actionLabel___ZWVhZz",
  "aN": "UserAreaPopout.module__actionHint___ZWVhZz",
  "oS": "UserAreaPopout.module__actionChevron___ZWVhZz",
  "qW": "UserAreaPopout.module__statusMenu___ZWVhZz" + " " + __webpack_require__(384626)["HG"],
  "C6": "UserAreaPopout.module__expiryPopup___ZWVhZz" + " " + __webpack_require__(384626)["HG"],
  "MH": "UserAreaPopout.module__statusMenuRow___ZWVhZz",
  "v0": "UserAreaPopout.module__statusMenuItem___ZWVhZz" + " " + __webpack_require__(384626)["AS"],
  "Tb": "UserAreaPopout.module__statusMenuIcon___ZWVhZz",
  "Te": "UserAreaPopout.module__statusMenuText___ZWVhZz",
  "Ye": "UserAreaPopout.module__statusMenuLabel___ZWVhZz",
  "wK": "UserAreaPopout.module__statusMenuDescription___ZWVhZz" + " " + __webpack_require__(384626)["Lo"],
  "Tc": "UserAreaPopout.module__statusMenuChevron___ZWVhZz",
  "L7": "UserAreaPopout.module__expiryItem___ZWVhZz" + " " + __webpack_require__(384626)["AS"],
  "ue": "UserAreaPopout.module__expiryLabel___ZWVhZz",
};

module.exports = exports;
